/* tslint:disable */

export class GuidelineHubInformationDto {
  id?: string;
  guidelineUniqueId?: string;
  isSyncedWithHub?: boolean;
  includePreview?: boolean;
  isPaid?: boolean;
  lastSyncedAt?: Date;
  importMode?: ImportMode;
}

export enum ImportMode {
  Readonly = 1,
  LocalEditable = 2,
  LocalEditableAndTemplate = 3,
  TemplateOnly = 4,
}
